export default "__VITE_ASSET__CDI6WfRb__"